import { useState } from "react"

import type { CompanyCertification, CompanyCertificationType } from "@/graphql/codegen/graphql"
import type { CertificationDialogType } from "@/screens/Companies/edit/components/certification/types"

interface UseCertificationModalReturn {
  openedDialog: CertificationDialogType | null
  selectedCertification: CompanyCertification | null
  preSelectedCertificationType: CompanyCertificationType | null
  preSelectedLocations: string[] | null
  setOpenedDialog: (dialog: CertificationDialogType | null) => void
  setPreSelectedCertificationType: (certificationType: CompanyCertificationType | null) => void
  setPreSelectedLocations: (locations: string[] | null) => void
  setSelectedCertification: (certification: CompanyCertification | null) => void
  reset: () => void
}

export const useCertificationDialog = (): UseCertificationModalReturn => {
  const [openedDialog, setOpenedDialog] = useState<CertificationDialogType | null>(null)
  const [preSelectedCertificationType, setPreSelectedCertificationType] = useState<CompanyCertificationType | null>(
    null
  )
  const [preSelectedLocations, setPreSelectedLocations] = useState<string[] | null>(null)
  const [selectedCertification, setSelectedCertification] = useState<CompanyCertification | null>(null)

  const reset = () => {
    setOpenedDialog(null)
    setSelectedCertification(null)
    setPreSelectedCertificationType(null)
    setPreSelectedLocations(null)
  }

  return {
    openedDialog,
    selectedCertification,
    preSelectedCertificationType,
    preSelectedLocations,
    setOpenedDialog,
    setPreSelectedCertificationType,
    setPreSelectedLocations,
    setSelectedCertification,
    reset,
  }
}
